// extracted by mini-css-extract-plugin
module.exports = {"logos":"GasBackPanel-module__logos___14xf9","logoColumn":"GasBackPanel-module__logoColumn___2bPAk","logoCircle":"GasBackPanel-module__logoCircle___gsx4s"};